import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@design-system/box';
import { __ } from '@design-system/i18n';
import { styled } from 'styled-components';
export const Logo = (_a) => {
    var { groupName = '', logoUrl, noBorder = false, size = {
        l: '96px',
        s: '64px',
    } } = _a, otherProps = __rest(_a, ["groupName", "logoUrl", "noBorder", "size"]);
    return (_jsx(Wrapper, Object.assign({ "$noBorder": noBorder, maxWidth: size, minWidth: size, size: size }, otherProps, { children: _jsx(Image, { alt: __('Logo of %{groupName}').i__({ groupName }), src: logoUrl }) })));
};
const Wrapper = styled(Box) `
  border-radius: 10px;
  border: ${({ $noBorder }) => ($noBorder ? 'none' : `2px solid white`)};
  overflow: hidden;
`;
const Image = styled.img `
  height: 100%;
  width: 100%;
  object-fit: cover;
`;
//# sourceMappingURL=Logo.js.map